export default {
  zh_CN: {
    points: 'Memeshot 币',
    reward: '奖励',
    title: 'Memeshot 币',
    desc: '	完成任务，领取 Memeshot 币',
    rules: '活动规则',
    myRewards: '我的奖励',
    pointsRank: '排行榜',
    totalRewards: '总奖励',
    viewDetails: '查看详情',
    myRank: '我的排名',
    myPoints: '我的 Memeshot 币',
    myX: '我的 X 账号',
    noBind: '暂未绑定',
    bindNow: '立即绑定',
    alreadyBind: '已绑定',
    link: '邀请链接',
    copyLink: '复制链接',
    myLink: '我的邀请链接',
    linkDesc: '编辑邀请文案',
    tweetsDesc: '加入 Memeshot 币奖励计划',
    rank: '排名',
    userName: '用户',
    inviteCommission: '邀请返佣',
    pointsRewards: 'Memeshot币奖励',
    noData: '暂无数据',
    pointsDetails: '奖励明细',
    tradeRewards: '交易奖励',
    inviteRewards: '邀请奖励',
    mediumRewards: '社媒奖励',
    contractRewards: '永续合约交易',
    stockTrade: '现货交易',
    dayRankRewards: '每日排名奖励',
    weekRankRewards: '周排名奖励',
    monthRankRewards: '月排名奖励',
    rewardsPoints: '已获得的 Memeshot 币',
    viewTweets: '查看推文',
    nickName: "用户名",
    nickNameDesc: "请输入用户名",
    save: "设置",
    saveMsg: "用户名设置成功",
    nicknameDesc: "至少 3 个字符，可含 字母、数字、. _ -",
    Inviter: "邀请人",
    // new rules
    tradeRewardsTitle: "交易赚 Memeshot Coins",
    tradeRewardsDesc1: '- $1 成交 = 1 Memeshot Coin',
    tradeRewardsDesc2: '- 新注册用户7天内的全部成交额额外 +10% Memeshot Coins',
    rankRewardsTitle: "交易量排行榜",
    rankRewardsDesc: "",

    dayliy: "日榜",
    weekly: "周榜",
    monthly: "月榜",
    invitationRewardsTitle: "邀请好友奖励",
    invitationRewardsDesc: "- 邀请人可实时获得被邀请好友每笔交易所获 Memeshot Coins 的 10 % 返利",
    rulesNote: "所获 Memeshot Coins 用于解锁特权与未来空投"
  },
  en_US: {
    points: 'Coins',
    reward: 'Rewards',
    title: 'Memeshot Coins',
    desc: 'Complete tasks to earn Memeshot Coins',
    rules: 'Rules',
    myRewards: 'My Rewards',
    pointsRank: 'Leaderboard',
    totalRewards: 'Total Rewards',
    viewDetails: 'View Details',
    myRank: 'My Rank',
    myPoints: 'My Coins',
    myX: 'My X Account',
    noBind: 'Not Connected',
    bindNow: 'Connect Now',
    alreadyBind: 'Connected',
    link: 'Referral Link',
    copyLink: 'Copy Link',
    myLink: 'My Referral Link',
    linkDesc: 'Customize your referral message',
    tweetsDesc: 'Join the Memeshot Coins Rewards Program',
    rank: 'Rank',
    userName: 'User',
    inviteCommission: 'Referral Commission',
    pointsRewards: 'Coins Rewards',
    noData: 'No Data',
    pointsDetails: 'Rewards History',
    tradeRewards: 'Trading Rewards',
    inviteRewards: 'Referral Rewards',
    mediumRewards: 'Social Rewards',
    contractRewards: 'Perpetual Trading',
    stockTrade: 'Spot Trading',
    dayRankRewards: 'Daily Rank Rewards',
    weekRankRewards: 'Weekly Rank Rewards',
    monthRankRewards: 'Monthly Rank Rewards',
    rewardsPoints: 'Reward Coins',
    viewTweets: 'View Tweet',
    nickName: 'Username',
    nickNameDesc: 'Enter username',
    save: 'Set',
    saveMsg: 'User name set successfully',
    nicknameDesc: "Min 3 chars: letters, numbers, . _ -",
    Inviter: "Invited by",
    // new rules
    tradeRewardsTitle: "Trade to Earn",
    tradeRewardsDesc1: '- Earn 1 Memeshot Coin for every $1 in filled volume.',
    tradeRewardsDesc2: '- New users get a 10 % Coin boost on all trades made within their first 7 days.',
    rankRewardsTitle: "Volume Leaderboards",
    rankRewardsDesc: "",
    dayliy: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    invitationRewardsTitle: "Invite & Earn",
    invitationRewardsDesc: "- Invite friends and collect a real-time 10 % rebate in Memeshot Coins on every Coin they earn from their trades.",
    rulesNote: "Use Memeshot Coins to unlock exclusive perks and qualify for future airdrops as they roll out."
  },
  ar_SA: {
    points: 'عملات',
    reward: 'المكافآت',
    title: 'عملات ميم شوت',
    desc: 'أكمل المهام لتحصل على مكافآت عملات ميم شوت',
    rules: 'القواعد',
    myRewards: 'مكافآتي',
    pointsRank: 'لائحة الصدارة',
    totalRewards: 'إجمالي المكافآت',
    viewDetails: 'عرض التفاصيل',
    myRank: 'ترتيبي',
    myPoints: 'عملاتي',
    myX: 'حسابك على X',
    noBind: 'غير مرتبط',
    bindNow: 'ربط X',
    alreadyBind: 'مرتبط',
    link: 'رابط الإحالة',
    copyLink: 'نسخ الرابط',
    myLink: 'رابط الإحالة',
    linkDesc: 'تخصيص رسالة الإحالة',
    tweetsDesc: 'انضم إلى برنامج مكافآت عملات ميم شوت',
    rank: 'الترتيب',
    userName: 'المستخدم',
    inviteCommission: 'عمولة الإحالة',
    pointsRewards: 'مكافآت العملات',
    noData: 'لا توجد بيانات',
    pointsDetails: 'سجل المكافآت',
    tradeRewards: 'مكافآت التداول',
    inviteRewards: 'مكافآت الإحالة',
    mediumRewards: 'مكافآت وسائل التواصل',
    contractRewards: 'تداول العقود الدائمة',
    stockTrade: 'التداول الفوري',
    dayRankRewards: 'مكافآت الترتيب اليومي',
    weekRankRewards: 'مكافآت الترتيب الأسبوعي',
    monthRankRewards: 'مكافآت الترتيب الشهري',
    rewardsPoints: 'عملات المكافآت',
    viewTweets: 'عرض التغريدة',
    nickName: 'اسم المستخدم',
    nickNameDesc: 'أدخل اسم المستخدم',
    save: 'حفظ',
    saveMsg: 'تم تعيين اسم المستخدم بنجاح',
    nicknameDesc: "٣ أحرف على الأقل: حروف، أرقام، . _ -",
    Inviter: "بدعوة من",
    // new rules
    tradeRewardsTitle: "مكافآت التداول",
    tradeRewardsDesc1: '- $1 من التداول = 1 عملة ميم شوت',
    tradeRewardsDesc2: '- المستخدمون الجدد يحصلون على +10% إضافية من عملات ميم شوت على جميع تداولاتهم خلال أول 7 أيام',
    rankRewardsTitle: "قائمة متصدري حجم التداول",
    rankRewardsDesc: "",
    dayliy: "يومي",
    weekly: "أسبوعي",
    monthly: "شهري",
    invitationRewardsTitle: "مكافآت دعوة الأصدقاء",
    invitationRewardsDesc: "- يحصل الداعي على 10% من عملات ميم شوت التي يكسبها الصديق المدعو من كل عملية تداول.",
    rulesNote: "تساهم عملات ميم شوت المكتسبة لفتح الامتيازات والحصول على الإيردروبات المستقبلية"
  },
  tr_TR: {
    points: 'Coinler',
    reward: 'Ödül',
    title: 'Memeshot Coin',
    desc: 'Görevleri tamamla, Memeshot Coin kazan',
    rules: 'Kurallar',
    myRewards: 'Ödüllerim',
    pointsRank: 'Lider Tablosu',
    totalRewards: 'Toplam Ödüller',
    viewDetails: 'Detayları Gör',
    myRank: 'Sıralamam',
    myPoints: 'Coinler',
    myX: 'X Hesabım',
    noBind: 'Bağlı değil',
    bindNow: 'Hemen bağlan',
    alreadyBind: 'Bağlandı',
    link: 'Bağlantı ',
    copyLink: 'Bağlantıyı Kopyala',
    myLink: 'Referans Linkim',
    linkDesc: 'Referans mesajını özelleştir',
    tweetsDesc: 'Memeshot Coin Ödül Programına katılın',
    rank: 'Sıra',
    userName: 'Kullanıcı',
    inviteCommission: 'Referans Komisyonu',
    pointsRewards: 'Coin Ödülleri',
    noData: 'Veri Yok',
    pointsDetails: 'Coin Geçmişi',
    tradeRewards: 'İşlem Ödülleri',
    inviteRewards: 'Referans Ödülleri',
    mediumRewards: 'Sosyal Medya Ödülleri',
    contractRewards: 'Perpetual Sözleşmeler',
    stockTrade: 'Spot İşlemler',
    dayRankRewards: 'Günlük Sıralama Ödülleri',
    weekRankRewards: 'Haftalık Sıralama Ödülleri',
    monthRankRewards: 'Aylık Sıralama Ödülleri',
    rewardsPoints: 'Ödül Coinleri',
    viewTweets: 'Tweet\'i Gör',
    nickName: 'Kullanıcı Adı',
    nickNameDesc: 'Kullanıcı adınızı girin',
    save: 'Ayarla',
    saveMsg: 'Kullanıcı adı başarıyla kaydedildi',
    nicknameDesc: "En az 3 karakter: harf, rakam, . _ -",
    Inviter: "Davet Eden",
    // new rules
    tradeRewardsTitle: "Ticaret yaparak Memeshot Coin kazan",
    tradeRewardsDesc1: '- $1 işlem = 1 Memeshot Coin',
    tradeRewardsDesc2: '- Yeni kayıtlı kullanıcılar 7 gün içinde tüm işlem hacmi için ekstra %10 Memeshot Coin alır',
    rankRewardsTitle: "İşlem Hacmi Sıralaması",
    rankRewardsDesc: "",
    dayliy: "Günlük",
    weekly: "Haftalık",
    monthly: "Aylık",
    invitationRewardsTitle: "Arkadaş Davet Ödülleri",
    invitationRewardsDesc: "- Davet edenler, davet edilen arkadaşlarının her işleminden kazandığı Memeshot Coin'lerin %10'unu gerçek zamanlı olarak alır",
    rulesNote: "Kazanılan Memeshot Coin'ler ayrıcalıkları açmak ve gelecekteki airdrop'lar için kullanılır"
  },
  ko_KR: {
    points: '코인',
    reward: '보상',
    title: 'Memeshot 코인',
    desc: '미션 완료하고 Memeshot 코인 받기',
    rules: '규칙',
    myRewards: '내 보상',
    pointsRank: '리더보드',
    totalRewards: '총 보상',
    viewDetails: '상세보기',
    myRank: '내 순위',
    myPoints: '내 코인',
    myX: '내 X 계정',
    noBind: '미연결',
    bindNow: '연결하기',
    alreadyBind: '연결됨',
    link: '링크',
    copyLink: '링크 복사하기',
    myLink: '내 추천 링크',
    linkDesc: '추천 메시지 편집하기',
    tweetsDesc: 'Memeshot 코인 보상 프로그램에 참여하세요',
    rank: '순위',
    userName: '사용자',
    inviteCommission: '추천 수수료',
    pointsRewards: '코인 보상',
    noData: '데이터 없음',
    pointsDetails: '코인 내역',
    tradeRewards: '거래 보상',
    inviteRewards: '추천 보상',
    mediumRewards: '소셜 보상',
    contractRewards: '무기한 선물',
    stockTrade: '현물거래',
    dayRankRewards: '일일 순위 보상',
    weekRankRewards: '주간 순위 보상',
    monthRankRewards: '월간 순위 보상',
    rewardsPoints: '보상 코인',
    viewTweets: '트윗 보기',
    nickName: '닉네임',
    nickNameDesc: '사용자 이름을 입력하세요',
    save: '저장',
    saveMsg: '사용자 이름이 저장되었습니다',
    nicknameDesc: "최소 3자 : 문자, 숫자, . _ -",
    Inviter: "초대자",
    // new rules
    tradeRewardsTitle: "거래로 Memeshot 코인 획득",
    tradeRewardsDesc1: '- $1 거래 = 1 Memeshot 코인',
    tradeRewardsDesc2: '- 신규 가입 사용자는 7일 내 모든 거래량에 대해 추가 +10% Memeshot 코인 지급',
    rankRewardsTitle: "거래량 순위",
    rankRewardsDesc: "",
    dayliy: "일간",
    weekly: "주간",
    monthly: "월간",
    invitationRewardsTitle: "친구 초대 리워드",
    invitationRewardsDesc: "- 초대자는 초대받은 친구의 모든 거래에서 획득한 Memeshot 코인의 10%를 실시간으로 리베이트 받습니다",
    rulesNote: "획득한 Memeshot 코인은 특권 해제 및 향후 에어드랍에 사용됩니다"
  }
}